import React from "react";
import { Switch, Route } from "react-router-dom";

import RootApp from "./RootApp";
import ErrorDisplay from "./generic/components/error-display/ErrorDisplay";
import LogoutPage from "./generic/pages/login-page/LogoutPage";

const MstrAppRoutes = () => (
  <Switch>
    <Route exact path="/mstr/error" component={ErrorDisplay} />
    <Route exact path="/mstr/logout" component={LogoutPage} />
    <Route exact path="/mstr/:application/error" component={ErrorDisplay} />
    <Route exact path="/mstr/:application" component={RootApp} />
    <Route path="/mstr" component={RootApp} />
  </Switch>
);

export default MstrAppRoutes;
